import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { AppBar, Toolbar, ImageList, ImageListItem, Skeleton } from '@mui/material';
import Modal from 'react-modal';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import SyncIcon from '@mui/icons-material/Sync';
const Search = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  let { value } = useParams();
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedId,setselectedId]=useState(null);
  const openModal = (image,id) => {
    setSelectedImage(image);
    setselectedId(id)
  }
  
  const closeModal = () => {
    setSelectedImage(null);
  }

  const loadMoreImages = async () => {
    setLoading(true)
    await axios.get(`https://pixabay.com/api/?key=39835288-9d7d47305bde5faa0a7c1c2b3&q=${value}&image_type=photo&per_page=12&page=${page + 1}`)
      .then(res => {
        setData([...data, ...res.data.hits]);
        setPage(page + 1);
        setLoading(false)
      })
      .catch(error => {
        console.log('Error fetching images:', error);
        setLoading(false)
      });
  }
  const downloadImage = (url, fileName) => {
    const download=document.getElementById("download");
    download.style.backgroundColor = "green";
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

      });
  }
  
  useEffect(() => {
    axios.get(`https://pixabay.com/api/?key=39835288-9d7d47305bde5faa0a7c1c2b3&q=${value}&image_type=photo&per_page=12`)
      .then(res => {
        setData(res.data.hits);
        setTotal(res.data.total);
      })
      .catch(error => {
        console.log('Error fetching images:', error);
      });
  }, [value]);

  return (
    <div>
      <AppBar style={{ 'position': "absolute", "margin": 0 ,"backgroundColor":"green"}}>
        <Toolbar><h1>{value}:{total}</h1></Toolbar>
      </AppBar>
      {data.length >= 1 ?
        <div id="container">
          <ImageList rowHeight={170} cols={3}>
            {data.map((img, index) => (
              <center key={index}>
                <div id="image-container"  onClick={() => openModal(img.largeImageURL,img.id)}>
                  <ImageListItem cols={1} >
                   
                      <img 
                        id="imglist" 
                        src={img.largeImageURL} 
                        alt={`photo-${img.id}`} 
                        loading="lazy"
                      />
                 
                    
                  </ImageListItem>
                  <p>{img.tags}</p>
                  
                </div>
              </center>
            ))}
          </ImageList>
        </div> : <div class="lds-ripple"><div></div><div></div><p style={{marginTop:100,marginLeft:20}}>Loading...</p></div>}
      <center>
        <hr></hr>
        {data.length >= 12 && <button
          className={loading ? 'show-more-button loading' : 'show-more-button'}
          onClick={loadMoreImages}
        >
          {loading ? <SyncIcon fontSize="small"/> : ''}
        </button>}
      </center>

      <Modal
        isOpen={selectedImage !== null}
        onRequestClose={closeModal}
        contentLabel="Image Modal"
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            

          },
          content: {
            width: '70%',
            maxWidth: '800px',
            background: 'transparent',
            borderRadius: '8px',
            height:'400px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            outline: 'none',
            border:"none",
            marginTop: '100px'
          
          
          }
        }}
      >
        {selectedImage && <img src={selectedImage} alt="Selected" style={{width:"100%"}} />}
        <Button variant="contained" style={{"position":"absolute","right":20,"top":20,"width":80,"height":30,"backgroundColor":"red"}} onClick={closeModal}>Close<CloseIcon/></Button>
        <Button id="download" variant="contained" style={{"position":"absolute","right":30,"left":20,"width":120,"height":30}} onClick={() => downloadImage(selectedImage, `photo-${selectedId}.jpg`)}>
                Download<DownloadIcon/>
              </Button>
      </Modal>
    </div>
  )
}

export default Search;
